"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _RemoveSortBtn = _interopRequireDefault(require("../RemoveSortBtn/RemoveSortBtn"));

var _GlobalRowFilter = _interopRequireDefault(require("../GlobalRowFilter/GlobalRowFilter"));

var _TableControls = require("./TableControls.styles");

var TableControls = function TableControls(_ref) {
  var className = _ref.className,
      clearSorting = _ref.clearSorting,
      removeSortHidden = _ref.removeSortHidden,
      hasSearch = _ref.hasSearch,
      controls = _ref.controls,
      setFilter = _ref.setFilter,
      getToggleAllPageRowsSelectedProps = _ref.getToggleAllPageRowsSelectedProps,
      globalFilter = _ref.globalFilter,
      setGlobalFilter = _ref.setGlobalFilter,
      searchPlaceholder = _ref.searchPlaceholder,
      disabledHint = _ref.disabledHint,
      disabled = _ref.disabled;
  var removeBtnOnly = !hasSearch && !controls;
  var removeSorting = (0, _jsxRuntime.jsx)(_Tooltip["default"], {
    title: disabled ? disabledHint : undefined,
    position: "top-start",
    maxWidth: 300,
    children: (0, _jsxRuntime.jsx)(_RemoveSortBtn["default"], {
      hidden: removeSortHidden,
      clearSorting: clearSorting,
      disabled: disabled,
      className: "grui ".concat(removeBtnOnly ? 'mb-10' : 'ml-5')
    })
  }); // All selection or column filter

  var renderControls = (0, _react.useMemo)(function () {
    return typeof controls === 'function' ? controls(setFilter, getToggleAllPageRowsSelectedProps, disabledHint) : controls;
  }, [controls, disabledHint, getToggleAllPageRowsSelectedProps, setFilter]); // Only have remove sort button

  if (removeBtnOnly) return (0, _jsxRuntime.jsx)("div", {
    className: "grui flex justify-end",
    children: removeSorting
  });
  if (!hasSearch && !controls) return null;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _TableControls.styles.base,
    className: className,
    children: [renderControls, (0, _jsxRuntime.jsxs)("div", {
      css: _TableControls.styles.searchContainer,
      children: [removeSorting, hasSearch && (0, _jsxRuntime.jsx)(_GlobalRowFilter["default"], {
        globalFilter: globalFilter,
        setGlobalFilter: setGlobalFilter,
        searchPlaceholder: searchPlaceholder,
        className: "grui ml-5",
        disabled: disabled,
        disabledHint: disabledHint
      })]
    })]
  });
};

TableControls.propTypes = {
  className: _propTypes.string,
  clearSorting: _propTypes.func,
  removeSortHidden: _propTypes.bool,
  hasSearch: _propTypes.bool,
  controls: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),
  getToggleAllPageRowsSelectedProps: _propTypes.func,
  setFilter: _propTypes.func,
  globalFilter: _propTypes.string,
  setGlobalFilter: _propTypes.func,
  searchPlaceholder: _propTypes.string,
  disabledHint: _propTypes.string,
  disabled: _propTypes.bool
};
TableControls.defaultProps = {
  className: undefined,
  clearSorting: function clearSorting() {},
  removeSortHidden: true,
  hasSearch: false,
  controls: undefined,
  setFilter: function setFilter() {},
  getToggleAllPageRowsSelectedProps: function getToggleAllPageRowsSelectedProps() {},
  globalFilter: undefined,
  setGlobalFilter: function setGlobalFilter() {},
  searchPlaceholder: undefined,
  disabledHint: undefined,
  disabled: false
};
var _default = TableControls;
exports["default"] = _default;
//# sourceMappingURL=TableControls.js.map